import React from 'react'
import { useTranslation } from 'react-i18next';
import img1 from '../../assets/img/about.jpeg'

const AboutTop = () => {
    const { t, i18n } = useTranslation();

    return (
        <>
            <section id="about-top" className="pb-5">
                <div className="container">
                    {i18n.language === 'en' ?
                        <div className="row">
                            <div className="col-lg-5 col-md-12 col-sm-12 col-12">
                                <div className="about_top_img">
                                    <img src={img1} alt="img" />
                                </div>
                            </div>
                            <div className="col-lg-7 col-md-12 col-sm-12 col-12">
                                <div className="about_top_left_content">
                                    <h2>Why Adam & Eve Medical Center</h2>

                                    <p>Adam & Eve is dedicated to becoming the industry leader in healthcare. In addition to being the best medical center in Abu Dhabi, we strive to bring together experts from all medical fields to provide the best and most comprehensive healthcare solutions at an affordable cost.</p>

                                    <p>We aim to harmonize therapeutic expertise, technological advancements, and professional care with empathy to bring value to our patients and provide exemplary performance.</p>


                                </div>

                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 mt-4">
                                <p>At Adam and Eve Medical Center, we endeavor to deliver the finest services to our customers by providing coordinated, compassionate, and high-quality healthcare treatments with equal stress on integral components of medical education and research. We pledge to set and practice the highest standards of healthcare delivery through our contemporary quality management system, such that we can guarantee our guests that our healthcare services not only meet but also exceed their expectations synergistically.</p>
                                <p>Adam and Eve Medical Centre is one of the best aesthetic clinics in Abu Dhabi. We offer a broad range of treatments that will help address many aesthetic concerns, from skin discoloration, acne, and wrinkles, to unwanted hair, stubborn fats, and everything in between. Since every person has their own cosmetic and dermatological needs, our highly experienced doctors and therapists create bespoke, personalized care for each of our clients to help them achieve their unique beauty goals.
                                    We also provide holistic therapy known as Hijama or cupping therapy to ensure that our clients stay healthy and radiant from the inside out.
                                </p>
                            </div>
                        </div>
                        : 
                        <div className="row">
                            <div className="col-lg-5 col-md-12 col-sm-12 col-12">
                                <div className="about_top_img">
                                    <img src={img1} alt="img" />
                                </div>
                            </div>
                            <div className="col-lg-7 col-md-12 col-sm-12 col-12">
                                <div className="about_top_left_content">
                                    <h2>لماذا عليكَ اختيارُ مركزِ آدم وحواء الطبيّ التخصصيّ؟</h2>

                                    <p>.مركز آدم وحواء الطبي التخصصي عنوانُ صحتك وجمالك 
لقد سخّر مركزُنا جهودَه المركّزة والحثيثة ليصبح رائدًا في مجال الرعاية الصحية. 
يعتبر مركزُ آدم وحواء الطبيّ التخصصيّ  أفضل مركزٍ طبيّ في أبو ظبي لكنه لم يتوقف عند هذا الحد فنحن نسعى جاهدين لجمع الخبراء في كافة  المجالات الطبية لتقديم أفضل وأشمل حلول الرعاية الصحية وبتكلفة معقولة</p>

                                    <p>كما نهدفُ إلى تنسيق الخبرات العلاجية والتقدم التكنولوجيّ و الرعاية المهنية مع التعاطف والقيم الإنسانية،  لتحقيق  أعلى مستويات جودة الخدمة   لمرضانا وتقديم نموذج يُحتذى  في الأداء الطبيّ المتميز.</p>

                                    <p>عاهدنا أنفسنا  في مركز آدم وحواء الطبي التخصصي،  أن نتمسّك بقيمنا الثابتة ألا وهي الالتزام بأعلى معايير الجودة  والنزاهة والثقة . 

نقدّم في مركزنا  الرعاية الأوليّة وكذلك الخدمات الطبية الوقائيّة ، فضلًا عن مجموعةٍ متنوعةٍ من حزم الرعاية الصحية لتلبية احتياجات مرضانا. 

كما نثابرُ باستمرار على توسيع وتطوير قدراتنا،  من أجل تلبية متطلبات  الرعاية الصحيّة في المنطقة .</p>


                                </div>

                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 mt-4">
                                <p>نحن في مركز آدم وحواء الطبيّ التخصصيّ  ، نسعى لتقديم أفضل الخدمات لعملائنا  من خلال توفير رعايةٍ صحيّةٍ مدروسةٍ  ورحيمة وعالية الجودة،  بالتزامن مع اهتمامنا الكبير بالتطورات العلمية والتعليمية وتقدّم البحثِ الطبيّ. 

نتعهدُ بالمحافظة  على أعلى معايير تقديم  الرعاية الصحية،  من خلال التزامنا بنظام إدارة الجودة المعاصر ، بحيث يمكننا أن نضمن رضا  زوار مركزنا بحيث لا نضاهي توقُّعاتهم فحسب بل نتفوّق عليها.

  يعتبر مركز آدم وحواء الطبيّ التخصصيّ من أفضل المراكز   التجميلية في أبوظبي،   فنحن نقدّمُ مجموعةً واسعةً من العلاجات التي من شأنها أن تساعد في معالجة العديد من المشكلات  التجميلية  ، مثل  تصبغات  الجلد وحب الشباب والتجاعيد والشعر غير المرغوب فيه والدهون العنيدة وغيرها من المشكلات . 
</p>
                                <p>الأطباءُ والمعالجون ذوو الخبرة الطويلة في مركزنا يدرسون  حالة كل مريض بشكلٍ شخصي بحيث يراعون تفرّد وخصوصية كلّ حالة ويقدّمون الرعاية الشخصية المخصصة لكل عميلٍ  من عملائنا لمساعدتهم على تحقيق أهدافهم الجماليّة المختلفة. 

كما نقدم علاجًا شاملاً يُعرف باسم الحجامة أو العلاج بالحجامة للتأكد من محافظة  العملاء على صحتهم وإشراقهم من الداخل إلى الخارج.
                                </p>
                            </div>
                        </div>
                        }
                </div>
            </section>
        </>
    )
}

export default AboutTop
